import React, { useContext, useEffect } from 'react';
import DashboardGadgetFilteringButton from './DashboardGadgetFilteringButton';
import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';
import ConfigureDashboardGadgetContext from '../../contexts/ConfigureDashboardGadgetContext';
import DashboardContext from '../../contexts/DashboardContext';
import PermissionGates from '../PermissionGates';
import PERMISSIONS from '../../permissionDefinitions';
import ContextMenuContext from '../../kingpin/atoms/ContextMenu/ContextMenuContext';
import EditStudioBlockOption from '../ReportCanvasCard/EditStudioBlockOption';
import { useCanOpenStudio } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const DashboardGadgetFilteringButtonContainer = () => {
  const { dashboardGadget, setIsEditing } = useContext(DashboardGadgetContext);
  const { closeMenu } = useContext(ContextMenuContext);
  const { open } = useContext(ConfigureDashboardGadgetContext);

  const onOpen = () => {
    open(dashboardGadget);
    closeMenu();
  };

  useEffect(() => {
    return () => {
      setIsEditing(false);
    };
  }, [setIsEditing]);

  return <DashboardGadgetFilteringButton open={onOpen} />;
};

const RenderGate = () => {
  const { templatedFrom } = useContext(DashboardContext);
  const { dashboardGadget } = useContext(DashboardGadgetContext);
  const canOpenStudio = useCanOpenStudio();
  if (!dashboardGadget || !!templatedFrom) {
    return null;
  }

  // Where the account has Studio, the gadget is edited there, on its block
  if (canOpenStudio) {
    return <EditStudioBlockOption />;
  }

  return (
    <PermissionGates.Has requiredPermission={PERMISSIONS.DASHBOARDS.EDIT}>
      <DashboardGadgetFilteringButtonContainer />
    </PermissionGates.Has>
  );
};

export default RenderGate;
